export default __webpack_public_path__ + "static/mini-helix-ps-1-a8e081ba0dbcdb7c68488f725847ec6d.jpg";